<form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="timelineEditor">
  <h2 mat-dialog-title>{{ Copy && Copy.Id ? 'Edit' : 'New' }} Timeline</h2>
  <mat-dialog-content *ngIf="Copy">
    <div class="row">
      <div class="col-12">
        <app-dropdown-option model="Timeline" discriminator="Type" name="Type" [(ngModel)]="Copy.Type"
                             placeholder="Type" required></app-dropdown-option>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Description</mat-label>
          <textarea matInput rows="8" name="Description"
                    [(ngModel)]="Copy.Description"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field>
          <mat-label>Start date</mat-label>
          <input name="StartDate" [ngModel]="Copy.Start | date: 'yyyy-MM-dd\THH:mm'"
                 (ngModelChange)="Copy.Start = $event" matInput type="datetime-local">
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field>
          <mat-label>End date</mat-label>
          <input name="EndDate" [ngModel]="Copy.End | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.End = $event"
                 matInput type="datetime-local">
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="fill-remaining-space"></div>
    <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
    <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
  </mat-dialog-actions>
</form>
